import React from 'react';

export default function BrandLogoLockup({
  logoUrl,
  alt = 'Logo',
  label = 'DiMax',
  logoHeight = 44,
  logoStyle,
  stacked = false,
  maxWidth,
  collapsed = false,
  center = false,
  T,
  style,
}) {
  const src = logoUrl || '/Logo-NSIA-Vie-Assurances.png';
  const accentA = T?.headerColor || 'var(--accent-primary, var(--Nixia-blue))';
  const accentB = T?.btnColor || 'var(--btn-primary, var(--Nixia-green))';

  const rootStyle = {
    display: 'inline-flex',
    flexDirection: stacked ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: center ? 'center' : 'flex-start',
    gap: collapsed ? 6 : 10,
    minWidth: 0,
    maxWidth: '100%',
    ...style,
  };

  const labelStyle = {
    fontFamily: 'var(--font-unbounded, var(--font-heading, system-ui))',
    fontWeight: 800,
    letterSpacing: '-0.03em',
    lineHeight: 1,
    fontSize: collapsed ? '11px' : 'clamp(13px, 1.25vw, 18px)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: maxWidth ?? (collapsed ? 28 : 220),
    width: stacked ? '100%' : undefined,
    textAlign: stacked ? 'center' : undefined,
    background: `linear-gradient(135deg, ${accentA} 0%, ${accentB} 100%)`,
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    textShadow: T
      ? `0 1px 0 ${T.isLight ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.22)'}`
      : undefined,
  };

  return (
    <span style={rootStyle} aria-label={`${alt} ${label}`}>
      <img
        src={src}
        alt={alt}
        style={{
          height: logoHeight,
          width: 'auto',
          display: 'block',
          objectFit: 'contain',
          flexShrink: 0,
          ...logoStyle,
        }}
        onError={(e) => {
          e.currentTarget.src = '/Logo-NSIA-Vie-Assurances.png';
        }}
      />
      <span style={labelStyle} title={label}>
        {label}
      </span>
    </span>
  );
}
